import {effect, inject, Injectable} from '@angular/core';
import {datadogRum} from '@datadog/browser-rum';
import {AsmService} from './asm.service';
import {EnvironmentService} from './environment.service';
import {DATADOG, UserCentricsService} from './user-centrics.service';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root',
})
export class DatadogService {
  private userCentricsService = inject(UserCentricsService);
  private userService = inject(UserService);
  private asmService = inject(AsmService);
  private environmentService = inject(EnvironmentService);

  init() {
    const env = window.location.host;
    const applicationId = this.environmentService.datadogRumApplicationId;
    const clientToken = this.environmentService.datadogRumClientToken;
    if (clientToken && applicationId) {
      datadogRum.init({
        applicationId: applicationId,
        clientToken: clientToken,
        site: 'datadoghq.eu',
        service: this.environmentService.datadogRumService || 'order-frontend',
        env,
        // Specify a version number to identify the deployed version of your application in Datadog
        version: this.environmentService.version || 'main',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackUserInteractions: true,
        trackBfcacheViews: true,
        defaultPrivacyLevel: 'allow',
        trackingConsent: 'not-granted',
      });

      effect(() => {
        datadogRum.setUser({
          id: this.userService.currentUser()?.uid ?? '-',
          asm: this.asmService.asmUser()?.agent?.email,
        });
      });

      effect(() => {
        if (this.userCentricsService.hasConsent(DATADOG)()) {
          datadogRum.setTrackingConsent('granted');
        } else {
          datadogRum.setTrackingConsent('not-granted');
        }
      });
    }
  }
}
